/* eslint-disable prettier/prettier */
import { TextField } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  width: 34%;
  height: 640px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px;
  background-color: #ffffff;
  /* O scroll pertence ao S.Content. Se o container também rolasse, o
     onScroll/IntersectionObserver do Content nunca seria acionado. */
  overflow: hidden;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
`;

export const TitleHeader = styled.h1`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4000000059604645px;
  text-align: center;
  color: #2d5bff;
`;

export const RowLine = styled.div`
  width: 100%;
  height: 0px;
  margin: 24px 0;
  border: 1px solid #ececec;
  opacity: 0px;
  border-color: #2d5bff;
`;

export const PesquisarHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 0px;
  gap: 20px;

  .type {
    display: flex;
    align-items: flex-start;
    width: 100%;
    gap: 8px;
  }
`;

export const TextHeader = styled.p`
  //styleName: XS/Semibold;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15.6px;
  text-align: center;
`;

export const PrimaryButton = styled.button<{ disabled?: boolean }>`
  background-color: ${({ disabled }) => (disabled ? "#eaefff80" : "#eaefff")};
  border-radius: 8px;
  height: 36px;
  width: 36px;
  cursor: pointer;

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
  }
`;

export const MessageField = styled(TextField)`
  background-color: #eaefff;
  border: none;
  border-radius: 8px;
  padding: 0 14px;
  height: 36px !important;
  width: 100%;
  font-family: Inter;
  :focus {
    outline: 2px solid #2d5bff;
  }
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-root {
    padding: 0;
    height: 100%;
    border-radius: 8px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Inter;
  /* flex + min-height 0 fazem este ser o elemento que rola dentro do card
     de altura fixa — sem isso a lista cresce e empurra o container. */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #ececec;
    border-radius: 8px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 8px;
`;

export const SummaryContent = styled.div<{ enlarge?: boolean }>`
  display: flex;
  width: 100%;
  gap: 8px;
  align-items: flext-start;
  justify-content: space-between;

  .text {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    p {
      font-size: 12px;
      line-height: 15.6px;
      color: #424248;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      ${({ enlarge }) =>
        enlarge
          ? "height: fit-content;"
          : "display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical;"}
      strong {
        font-weight: 600;
      }
    }
  }

  .expand {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 2px;
    height: 100%;
    width: max-content;

    .icon {
      padding-right: 4px;
    }

    p {
      font-size: 10px;
      color: #a3a3a6;
      font-weight: 600;
      white-space: nowrap;
    }

    .dataHora {
      font-size: 10px;
      color: #424248;
      font-weight: 500;
    }
  }
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  overflow-x: auto;

  p {
    font-size: 12px;
    font-weight: 400;
    color: #424248;
    width: 100%;
    height: 100%;
    strong {
      font-weight: 600;
    }
  }
`;

export const IconContainer = styled.div<{ bg: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px !important;
  width: 36px !important;
  border-radius: 8px;
  background-color: ${(props) => props.bg ?? "gray"};
`;

export const Divider = styled.div`
  border-top: 1px solid #d5d5d5;
  width: 100%;
  height: 1px;
`;

export const TrocarArquivoButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  gap: 6px;
  margin-top: 4px;
  padding: 8px 12px;
  background: #eaefff;
  border: 1px solid #2d5bff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #2d5bff;

  :hover {
    background: #dbe3ff;
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
